/* Range endpoints use Mantine's filled selected color; match the lighter in-range fill. */
.weekRangePicker :global(button[data-first-in-range]),
.weekRangePicker :global(button[data-last-in-range]) {
    background-color: var(--mantine-primary-color-light);
    color: var(--mantine-color-text);
}

.weekRangePicker :global(button[data-first-in-range]:hover),
.weekRangePicker :global(button[data-last-in-range]:hover),
.weekRangePicker :global(button[data-first-in-range]:active),
.weekRangePicker :global(button[data-last-in-range]:active) {
    background-color: var(--mantine-primary-color-light);
    color: var(--mantine-color-text);
}
